/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { Drawer, Grid, TextField, Button } from '@mui/material'
import clsx from 'clsx'
import useStyles from './styles'

function Comment(props) {
    const anchor = 'bottom'
    const classes = useStyles()

    return (
        <React.Fragment>
            <Drawer
                anchor={anchor}
                open={props.isComment}
                onClose={() => props.setIsComment(false)}
            >
                <Grid className={clsx(null, { [null]: anchor })}>
                    <Grid className={classes.gridComment}>
                        <TextField
                            label={"توضیحات"}
                            multiline
                            autoFocus
                            rows={5}
                            onChange={(e) => props.setComment(e.target.value)}
                            value={props.comment}
                            variant="outlined"
                            placeholder={".توضیحات خود را در این قسمت وارد کنید"}
                            fullWidth
                        />
                        <Button
                            onClick={() => props.setIsComment(false)}
                            fullWidth variant="contained" color="primary"
                        >
                            ثبت نظر
                        </Button>
                    </Grid>
                </Grid>
            </Drawer>
        </React.Fragment >
    );
}

export default Comment